import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceGenDocToIRBCancellationQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_gen_doc_to_irb_cancellation_queue_container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceGenDocToIRBCancellationQueueService extends BaseApiPublicLoginTemplateService<MyEInvoiceGenDocToIRBCancellationQueueContainerModel, MyEInvoiceGenDocToIRBCancellationQueueContainerModel, MyEInvoiceGenDocToIRBCancellationQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-cancellation-queues/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-cancellation-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-cancellation-queues/backoffice-ep'
    this.httpClient = http;
  }

   postMultipleToProcess(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-cancellation-queues/submit-to-lhdn/backoffice-ep';
      if (this.endpoint_path && visa.api_domain_url) {
        customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "e-invoice/gendoc-to-irb-cancellation-queues/submit-to-lhdn/backoffice-ep";
      }
      return this.httpClient.post<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

}
